import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { News_component } from './components/News_component/News_component';
import News_item from './pages/news_item/News_item';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
